<template>
  <div class="hello">
    <div class="helloTop">
      <div class="BottonOne">
        <div class="BorOne">
          <div class="BackOne">
            <div class="Boss">服务行业</div>
            <div class="BossOne">知识付费</div>
            <div class="BossOne">兴趣培训</div>
            <div class="BossOne">企业培训</div>
            <div class="BossOne">大健康</div>
            <div class="BossOne">K12教育</div>
            <div class="BossOne">医疗美容</div>
          </div>
          <div class="BackOne">
            <div class="Boss">应用场景</div>
            <div class="BossOne">直播互动</div>
            <div class="BossOne">营销转化</div>
            <div class="BossOne">产品交付</div>
            <div class="BossOne">用户服务</div>
            <div class="BossOne">裂变拉新</div>
            <div class="BossOne">专业培训</div>
          </div>
          <div class="BackOne">
            <div class="Boss">关于我们</div>
            <div class="BossOne"><a href="/projectA">公司简介</a></div>
            <div class="BossOne"><a href="/new">新闻动态</a></div>
            <!-- <div class="BossOne">联系我们</div> -->
          </div>
        </div>
        <div class="BorTwo">
          <!-- <div class="OneBoss"></div> -->
          <div class="OneBoss">account@mischool.com.cn</div>
          <div class="OneYou">联系我们</div>
          <div class="OneTwo">
            <div class="YouBoss you">
              <img
                style="border-radius: 4px"
                src="../assets/official/微信图片_20230324112229 1.png"
                alt=""
              />
              <div style="text-align: center">大米智课公众号</div>
            </div>
            <div class="YouBoss">
              <img src="../assets/official/组 2.png" alt="" />
              <div style="text-align: center">添加官方客服</div>
            </div>
          </div>
        </div>
      </div>
      <div class="TheOne">
        <div class="TheOneYou">
          <!--<div>上海公司：上海市静安区江场三路238号市北半岛国际中心</div>-->
          <!-- <div>南京公司：南京市建邺区奥体大街69号新城科技园</div> -->
          <!--<div>北京公司：北京市朝阳区望京湖光中街一号鹏景阁大厦</div>-->
        </div>
        <!-- <div class="TheOneYou">投诉建议：ocloud@occloud.net</div> -->
      </div>
      <div class="TheOneLove">
        <div class="TheOneYou">
          Copyright ©2019—2025 OCCloud Cloud All Rights Reserved.
        </div>
        <div class="TheOneYou">
          南京考拉在线信息技术有限公司 版权所有 |
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            class="iii"
            v-if="host.includes('miscrm')"
            >苏ICP备2024057838号-3</a
          >
          <div v-else style="display: inline-block">
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              class="iii"
            >苏ICP备2024057838号-1</a
            >
            <img style="margin-left: 10px; margin-right: 5px; width: 15px;" src="./../assets/waba.png">
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=32010502011180"
              rel="noreferrer"
              class="iii"
              target="_blank">苏公网安备32010502011180号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomBoss',
  data() {
    return {
      host: window.location.host,
    }
  },
  methods: {
    handleClick2(event) {
      // report(true)
      // debugger
      //  this.$removeItem('shijian')
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  color: #9b9ea0;
  text-decoration: none;
}
.iii {
  text-decoration: underline;
}
.hello {
  width: 1440px;
  // height: 550px;
  padding: 0 0 20px;
  display: flex;
  justify-content: center;
  background: #252525;
  margin-bottom: 120px;
  .helloTop {
    width: 1200px;
    height: 100%;

    /* padding:0 120px; */
    .BottonOne {
      display: flex;
      padding-top: 41px;
      justify-content: space-between;
      margin-bottom: 29px;
      .BorOne {
        /* background: #0075ff; */
        /* height: 100%; */

        display: flex;
        .BackOne {
          width: 215px;
          .Boss {
            padding: 20px 0 24px;
            font-size: 16px;
            color: #d7d8d9;
            cursor: default;
          }
          .BossOne:hover a {
            color: #ffffff;
          }
          .BossOne {
            padding: 16px 0 0;
            font-size: 14px;
            color: #9b9ea0;
          }
        }
      }
      .BorTwo {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        cursor: default;
        .OneBoss {
          height: 42px;
          font-size: 20px;
          font-weight: 800;
          color: #ffffff;
          line-height: 42px;
          margin: 6px 0;
        }
        .OneYou {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #d7d8d9;
          line-height: 14px;
          margin-bottom: 32px;
        }
        .OneTwo {
          display: flex;
          .YouBoss {
            img {
              width: 110px;
              height: 110px;
              margin-bottom: 8px;
            }
            div {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #d7d8d9;
              line-height: 14px;
            }
          }
          .you {
            margin-right: 40px;
          }
        }
      }
    }
    .TheOne {
      display: flex;
      padding: 0 0 40px;
      margin: 0 0 16px;
      border-bottom: 1px solid #9b9ea0;
      cursor: default;
      .TheOneYou {
        line-height: 28px;
        color: #9b9ea0;
        font-size: 14px;
        font-weight: 400;
        margin-right: 48px;
      }
      .TheOneLove {
      }
    }
    .TheOneLove {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: default;
      .TheOneYou {
        line-height: 28px;
        color: #9b9ea0;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}
</style>
